module.exports = __webpack_public_path__ + "static/media/wifi.693168a4.svg";